import { create } from 'zustand'

interface DownloadsState {
  currentPath: string
  setCurrentPath: (path: string) => void
}

export const useDownloadsStore = create<DownloadsState>()((set) => ({
  currentPath: '/',
  setCurrentPath: (path) => set({ currentPath: path }),
}))